<template>
  <div>    
    <div class="row">
        <div class="col-sm-12 col-md-4 col-lg-4">
            <span class="lblselect2">Filial:</span>
            <select id="cbfilialmetas" data-placeholder="Selecione uma filial" v-model="idfilialmeta" data-allow-clear="true" style="width:100%;">
            </select>
        </div>                                
        <div class="col-sm-12 col-md-2 col-lg-2">
            <label for="edmesmeta">Mês:</label>
            <select id="edmesmeta" class="form-control form-control-sm" v-model="mesmeta" data-bv-group=".group">
                <option value="1">Janeiro</option>
                <option value="2">Fevereiro</option>
                <option value="3">Março</option>
                <option value="4">Abril</option>
                <option value="5">Maio</option>
                <option value="6">Junho</option>
                <option value="7">Julho</option>
                <option value="8">Agosto</option>
                <option value="9">Setembro</option>
                <option value="10">Outubro</option>
                <option value="11">Novembro</option>
                <option value="12">Dezembro</option>
            </select>
        </div>
        <div class="col-sm-12 col-md-2 col-lg-1">
            <label for="edanometa">Ano:</label>
            <select name="edanometa" class="form-control form-control-sm" id="edanometa" v-model="anometa" style="text-align: right;">
                <option v-for="(ano, index) in anoslistameta" :key="index" :value="ano.ano">{{ ano.ano }}</option>
            </select>
        </div>
        <div class="col-sm-1 col-md-1 col-lg-1">
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="mtdmetasvendedores()" title="Atualizar" style="margin-top: 20px;"><i class="fa fa-refresh"></i></button>                                    
        </div>                                                                                                                                
    </div>
    <div v-show="isloading" class="row">
        <dashboard_skeleton></dashboard_skeleton>
      </div> 
      <div v-show="!isloading" class="row">
        <div class="col-md-12 grafico-metavendedores">
            <graficometavendedores :titulo="''" :agrupamento="gruponomes" :series="series"></graficometavendedores>                                  
        </div>
    </div>
    <div class="row" style="margin-top:25px;">
        <div class="col-md-12">
            <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover" style="font-size: 12px;">
                    <thead class="thead-light">
                        <tr class="font-weight-bold">
                            <th>Vendedor</th>
                            <th>Meta</th>
                            <th>Vendas</th>
                            <th>Falta</th>
                            <th>Concluído</th>
                            <th>Sit.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(meta, index) in dadosmetas" v-bind:key="index">
                            <td class="font-weight-bold">{{ meta.nome }}</td>
                            <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(meta.totalmeta) }}</td>
                            <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(meta.totalvendas) }}</td>
                            <td class="text-right font-weight-bold" v-bind:class="parseFloat(meta.totalmeta) < parseFloat(meta.totalvendas) ? 'text-verde': 'text-danger'">{{ mtdformatavalordecimal(meta.vlrestante) }}</td>
                            <td class="text-center font-weight-bold" v-bind:class="parseFloat(meta.totalmeta) < parseFloat(meta.totalvendas) ? 'text-verde': 'text-danger'">
                                <span title="Percentual concluído da meta">{{ meta.perc }}% </span>
                                <span v-if="parseFloat(meta.totalmeta) > parseFloat(meta.totalvendas)" class="text-center font-weight-bold text-alerta" title="Percentual que falta para bater a meta"> - {{ 100 - parseFloat(meta.perc) }}%</span>   
                            </td>                                                    
                            <td class="text-center">
                                <i v-if="parseFloat(meta.totalvendas) >= parseFloat(meta.totalmeta)" class="fa fa-check-circle" style="color: #0acf97; font-size: 18px;" title="Meta concluída"></i>                                                        
                                <i v-else class="fa fa-times-circle text-danger" style="font-size: 18px;" title="Meta NÃO concluída"></i>
                            </td>
                        </tr>
                        <tr >
                            <td class="font-weight-bold">TOTAL GERAL</td>
                            <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(totalgeralmeta) }}</td>
                            <td class="text-right font-weight-bold">{{ mtdformatavalordecimal(totalgeralvendasmetas) }}</td>
                            <td class="text-right font-weight-bold" v-bind:class="parseFloat(totalgeralmeta) < parseFloat(totalgeralvendasmetas) ? 'text-verde': 'text-danger'">{{ mtdformatavalordecimal(totalgeralmeta - totalgeralvendasmetas) }}</td>
                            <td class="text-center font-weight-bold" v-bind:class="parseFloat(totalgeralmeta) < parseFloat(totalgeralvendasmetas) ? 'text-verde': 'text-danger'">
                                
                            </td>                                                    
                            <td class="text-center">
                                <i v-if="parseFloat(totalgeralvendasmetas) >= parseFloat(totalgeralmeta)" class="fa fa-check-circle" style="color: #0acf97; font-size: 18px;" title="Meta concluída"></i>                                                        
                                <i v-else class="fa fa-times-circle text-danger" style="font-size: 18px;" title="Meta GERAl NÃO concluída"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>                                        
            </div>
        </div>
    </div>  
  </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoMetaVendedores from '../../components/cmpgraficometasvendedores.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
   'graficometavendedores' : GraficoMetaVendedores,
   'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        
        showpopover             : false,
        isloading               : false,  
        usuariologado           : this.$store.state.usuario,
        
        //variáveis da meta
        dadosmetas              : [],
        mesmeta                 : 1,
        anometa                 : 1,
        anoslistameta           : [],
        gruponomes              : [],
        series                  : [],
        totalgeralvendasmetas   : 0,
        totalgeralmeta          : 0,
        idfilialmeta            : null,
}
   
  },
  props: [
     'utodasfiliais',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmetasvendedores(){
            var vself           = this;
            vself.$emit('handlerLoader', true);
            if (parseInt(vself.utodasfiliais) === 0 && vself.idfilialmeta !== null){
                vself.$toastr.i('Informe uma filial para consulta', 'Informação!');
            }else{
                // let loader          = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},                    
                    {parametro: 'op',           valor : 'metavendas'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                    {parametro: 'mes',          valor : vself.mesmeta},
                    {parametro: 'ano',          valor : vself.anometa},
                    {parametro: 'idfilial',     valor : vself.idfilialmeta === null ? 0 : vself.idfilialmeta},

                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    // loader.hide();							
                    vself.dadosmetas = response.data.metasvendas;
                    vself.mtdmontagraficometas(); 
                    vself.$emit('handlerLoader', false);                                      				                    
                }).catch(function (response) {
                    // loader.hide();
                    vself.$emit('handlerLoader', false);

                });   
            }              
        },
        mtdmontagraficometas(){
            let vself = this;
            vself.totalgeralvendasmetas = 0;
            vself.totalgeralmeta        = 0;
            vself.gruponomes = [];
            vself.series     = [];
            let gpn          = [];
            for (let i = 0; i < vself.dadosmetas.length; i++) {
                gpn.push(vself.dadosmetas[i].nome);
            }
            let vnd = [];
            for (let i = 0; i < vself.dadosmetas.length; i++) {
                vnd.push(parseFloat(vself.dadosmetas[i].totalvendas));
                vself.totalgeralvendasmetas = vself.totalgeralvendasmetas + parseFloat(vself.dadosmetas[i].totalvendas);
            }

            let mt = [];
            for (let i = 0; i < vself.dadosmetas.length; i++) {
                mt.push(parseFloat(vself.dadosmetas[i].totalmeta));
                vself.totalgeralmeta = vself.totalgeralmeta + parseFloat(vself.dadosmetas[i].totalmeta);
            }

            let series = [
                {
                    name: 'Vendas',
                    type: 'bar',
                    data: vnd
                },
                {
                    name: 'Metas',
                    type: 'bar',
                    data: mt
                }
            ];
            vself.series     = series;                                
            vself.gruponomes = gpn;
        },
    
  },
  mounted(){
      let vself = this;
      $("#cbfilialmetas").select2({
            id: function (e) {return e.codfil},
            ajax: {						
                url: vself.$store.state.configpaths.pathselect2sql,						
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q		: params.term,
                        idclientesac : vself.$store.state.filialpadrao.idcliente,
                        sqlini	: sqliniusuario,
                        sqlfim	: sqlfimusuario,
                        cpid	: 'codfil',
                        cpdesc	: 'fantasia'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.idfilialmeta = $("#cbfilialmetas").val();
        });


        let dataatual  = new Date();
        let anoatual   = dataatual.getFullYear();

        this.anometa   = parseInt(anoatual);
        this.mesmeta   = parseInt(dataatual.getMonth()) + 1;             

        this.anoslistameta = [];

        for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
            anoatual = index === 0 ? parseInt(anoatual) : parseInt(anoatual) + 1;
            let anox = {
                'ano' : anoatual
            };
            this.anoslistameta.push(anox);
        }

    setTimeout(() => {
        this.mtdmetasvendedores();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
    